import { render, staticRenderFns } from "./page-edit.vue?vue&type=template&id=042fcbb3&"
import script from "./page-edit.vue?vue&type=script&lang=js&"
export * from "./page-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports